<div id="attribute">
    <div class="title-head" fxLayout="row" fxLayoutAlign="space-between center" color="primary">
        <span>
            Add {{title}}
        </span>
        <button [attr.guide]="'product-link-btn-1' + '__' + sanitizedUrl" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>
    <div class="padding-11" style="overflow-x: auto;">
   <div class="editSets" fxLayout="column">
            <calsoft-list (filterChangeColumn)="onFilterChangeColumn($event)" (filterChange)="onFilterChange($event)" name="{{title}}" [columns]="columns"
                style="margin-bottom: 0px;">

                <div id="responsieTable" class="container">
                    <div [ngClass]="productList.length>=5?'minimum':'none'">
                        <table class="rwd-table">
                            <tbody>
                                <tr>
                                    <th></th>
                                    <th>NAME</th>
                                    <th>TYPE</th>
                                    <th>ATTRIBUTE SET NAME </th>
                                    <th>SKU</th>
                                   
                                </tr>

                        
                                <tr *ngFor="let product of productList;let i=index">
                                    <td data-th="">


                                        <mat-checkbox [attr.guide]="'product-link-chk-2' + '__' + sanitizedUrl" [checked]="newlyAddedList.indexOf(product.entityId) >= 0" 
                                              (change)="onChange(product.entityId, $event.checked,product)">

                                        </mat-checkbox>
                                    </td>
                                    <td data-th="Name">
                                        {{product.name }}
                                    </td>
                                    <td data-th="Type">
                                        {{product.type }}
                                    </td>
                                    <td data-th="ATTRIBUTE SET NAME">
                                        {{product.attributeSetName }}
                                    </td>
                                    <td data-th="sku">
                                        {{product.sku }}
                                    </td>
                          
                                </tr>
                            </tbody>
                        </table>
                        <div fxLayout="row" *ngIf="productList.length==0" fxLayoutAlign="center center">
                            <span>No Records Found</span>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" class="pager" fxLayoutAlign="end center" fxLayoutGap="5px">
                    <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
                    <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
                        [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue">
                    </mat-paginator>
                </div>
            </calsoft-list>
        </div> 
        <div class="padding-top10 " fxLayoutGap="10px">
            <button [attr.guide]="'product-link-btn-3' + '__' + sanitizedUrl" type="button" (click)="addSelectedProduct()" mat-raised-button >Add  {{title}}
            </button>
        </div>
    </div>
</div>
